export default __webpack_public_path__ + "static/0109-50f912f584f3aed07082fe19443f3042.png";